import script from "./WReportImages.vue?vue&type=script&setup=true&lang=ts"
export * from "./WReportImages.vue?vue&type=script&setup=true&lang=ts"

import "./WReportImages.vue?vue&type=style&index=0&id=3dc7f071&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dc7f071"]])

export default __exports__